import React, { useState } from "react";

const PDJobGeneration = () => {
    const [showImage, setShowImage] = useState(false);

    const modules = [
        'Deep Thinking - "97% of people operate at surface-level thinking."',
        'IKIGAI - "Know Why Your Existence Is"',
        'Attention Signals Assessment - "Attention is the new currency."',
        'ROACHES Daily Flow - Daily Personal Operating Dashboard',
        'Digital Entrepreneurship Assessment - Initial Assessment',
        'Behavior Operating System (5W1H) - Before Every Important Action Ask',
        'GenAI Boundaries - GenAI is a Co-Pilot, Not a Replacement for Thinking',
    ];

    return (
        <div className="relative min-h-screen bg-gradient-to-b from-black via-gray-900 to-black text-white px-3 py-4 rounded-2xl border-t-2 border-purple-600">

            <div className="text-center mb-6">
                <h1 className="text-lg lg:text-xl font-bold text-purple-300">
                    🚀 GenZ / Next Gen Digital Franchise
                </h1>

                <h2 className="text-sm lg:text-lg text-purple-200 mt-2">
                    Entrepreneur Skill Orientation
                </h2>
                <p className="text-[10px] lg:text-xs text-gray-300 mt-1">
                    <span className="text-emerald-400">✅ Zero Experience Needed</span>
                    <span className="text-gray-500"> • </span>
                    <span className="text-sky-400">📱 Mobile-First Execution</span>
                </p>                

                <p className="text-xs lg:text-sm text-gray-300 mt-3 max-w-4xl mx-auto">
                    Open your first structured digital business, franchise, or boutique and
                    earn while contributing to yourself, your family, and society.
                </p>

                <div className="mt-4 bg-gray-900 border border-purple-700 rounded-xl p-3 relative">
                    <img
                        src="/assets/jobgeneration2.webp"
                        alt="GenZ Digital Franchise Jobs"
                        className="w-full max-w-md mx-auto rounded-xl border border-purple-500"
                    />
                </div>

                <button
                    onClick={() => setShowImage((prev) => !prev)}
                    className="w-fit mt-2 text-xs lg:text-sm px-3 py-1 rounded-full bg-purple-700 hover:bg-purple-600 transition-colors"
                >
                    🖼️ View Program Visual
                </button>

                {showImage && (
                    <div className="mt-4 bg-gray-900 border border-purple-700 rounded-xl p-3 relative">
                        <img
                            src="/assets/jobgeneration1.webp"
                            alt="GenZ Digital Franchise Orientation"
                            className="w-full max-w-md mx-auto rounded-xl border border-purple-500"
                        />
                    </div>
                )}
            </div>

            {/* Eligibility */}
            <div className="bg-gray-900 border border-purple-800 rounded-2xl p-4 mb-4">
                <h3 className="text-purple-300 font-semibold mb-3">
                    🎯 Eligibility
                </h3>

                <div className="grid md:grid-cols-2 gap-2 text-xs lg:text-sm">
                    <p className="text-xs lg:text-sm text-gray-100">🎓 Qualification: Undergraduate & Above</p>
                    <p className="text-xs lg:text-sm text-gray-100">📅 Age: Born Between 1997 - 2010</p>
                    <p className="text-xs lg:text-sm text-gray-100">📱 Experience: 0 (Mobile Proficiency Mandatory)</p>
                    <p className="text-xs lg:text-sm text-gray-100">🏠 Location: Remote (Home / Hostel / Own Shop)</p>
                </div>
            </div>

            {/* Program Highlights */}
            <div className="grid md:grid-cols-2 gap-3 mb-4">

                <div className="bg-gray-800 rounded-xl p-4">
                    <h3 className="text-purple-300 font-semibold mb-3">
                        💼 Opportunity
                    </h3>

                    <ul className="space-y-2 text-xs lg:text-sm text-gray-200">
                        <li className="text-xs lg:text-sm text-gray-100">✅ Structured Digital Business</li>
                        <li className="text-xs lg:text-sm text-gray-100">✅ Digital Franchise Recognition</li>
                        <li className="text-xs lg:text-sm text-gray-100">✅ Digital Boutique Model</li>
                        <li className="text-xs lg:text-sm text-gray-100">✅ Flexible Working Hours</li>
                        <li className="text-xs lg:text-sm text-gray-100">✅ Work From Anywhere</li>
                    </ul>
                </div>

                <div className="bg-gray-800 rounded-xl p-4">
                    <h3 className="text-purple-300 font-semibold mb-3">
                        🎁 Benefits
                    </h3>

                    <ul className="space-y-2 text-xs lg:text-sm text-gray-200">
                        <li className="text-xs lg:text-sm text-gray-100">💳 Seed Working Credit: ₹1,499</li>
                        <li className="text-xs lg:text-sm text-gray-100">📜 Certified Digital Franchise Certificate</li>
                        <li className="text-xs lg:text-sm text-gray-100">🏆 Franchise Recognition Certificate</li>
                        <li className="text-xs lg:text-sm text-gray-100">🚀 GenZ Startup Accelerator Recognition</li>
                    </ul>
                </div>
            </div>

            {/* Modules */}
            <div className="bg-gray-900 border border-purple-800 rounded-2xl p-4 mb-4">
                <h3 className="text-purple-300 font-semibold mb-4">
                    📚 Body of Knowledge (Online Workshop)
                </h3>

                <div className="space-y-2">
                    {modules.map((module, index) => (
                        <div
                            key={index}
                            className="bg-gray-800 rounded-lg p-3 text-xs lg:text-sm"
                        >
                            <span className="text-purple-300 font-semibold">
                                Module {index + 1}
                            </span>
                            {" - "}
                            {module}
                        </div>
                    ))}
                </div>
            </div>

            {/* Duration */}
            <div className="grid md:grid-cols-3 gap-1 mb-2">

                <div className="bg-gray-800 rounded-xl p-1 text-center">
                    <div className="text-lg lg:text-xl mb-1">⏳</div>
                    <p className="text-purple-300 text-xs lg:text-sm font-semibold">Duration</p>
                    <p className="text-xs lg:text-sm mt-1 text-cyan-200">
                        3 Days + Live Mini Project
                    </p>
                    <p className="text-xs lg:text-sm text-gray-200">
                        (~12 Person Hours)
                    </p>
                </div>

                <div className="bg-gray-800 rounded-xl p-1 text-center">
                    <div className="text-lg lg:text-xl mb-1">🎯</div>
                    <p className="text-purple-300 text-xs lg:text-sm font-semibold">
                        Earnings
                    </p>
                    <p className="text-xs lg:text-sm mt-1 text-gray-100">
                        Set Your Own Goal
                    </p>
                    <p className="text-xs lg:text-sm text-gray-200">
                        Based on Time, Focus & Effort
                    </p>
                </div>

                <div className="bg-gray-800 rounded-xl p-1 text-center">
                    <div className="text-lg lg:text-xl mb-1">💰</div>
                    <p className="text-purple-300 text-xs lg:text-sm font-semibold">
                        Fee Free
                    </p>
                    <p className="text-xs lg:text-sm  text-gray-200">
                        You Pay Commitment Fee ₹1,499 + GST
                    </p>
                </div>
            </div>

            {/* Market */}
            <div className="bg-gray-900 border border-purple-800 rounded-2xl p-4 mb-4">
                <h3 className="text-cyan-200 text-xs lg:text-sm font-semibold mb-2">
                    🌐 Market Opportunity
                </h3>

                <p className="text-xs lg:text-sm text-gray-200 leading-relaxed">
                    Every mobile user around you, MSMEs, corporates, women,
                    SHGs, parents, students, schools, colleges, universities,
                    hostels, healthcare professionals, blue-collar workers,
                    contractors, professionals and digitally connected
                    communities.
                </p>
            </div>

            {/* Advanced Program */}
            <div className="bg-gradient-to-r from-purple-900/30 to-indigo-900/30 border border-purple-700 rounded-xl p-2">
                <h3 className="text-cyan-200 text-xs lg:text-sm font-semibold mb-1">
                    🚀 Advanced Assessment (Optional)
                </h3>

                <p className="text-xs lg:text-sm text-gray-200">
                    12-Week Online Entrepreneurship Program with State-of-the-Art
                    CTA Tools and Mentor Guidance.
                </p>

                <p className="text-xs lg:text-sm text-gray-300 mt-1">
                    Add-on Custom Fee Applicable.
                </p>
            </div>

        </div>
    );
};

export default PDJobGeneration;